var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobBreifCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8332 5.83333C13.8332 5.05836 13.8332 4.67087 13.748 4.35295C13.5168 3.49022 12.8429 2.81635 11.9802 2.58519C11.6623 2.5 11.2748 2.5 10.4998 2.5C9.72486 2.5 9.33737 2.5 9.01946 2.58519C8.15673 2.81635 7.48286 3.49022 7.25169 4.35295C7.1665 4.67087 7.1665 5.05836 7.1665 5.83333M4.83317 17.5H16.1665C17.0999 17.5 17.5666 17.5 17.9232 17.3183C18.2368 17.1586 18.4917 16.9036 18.6515 16.59C18.8332 16.2335 18.8332 15.7668 18.8332 14.8333V8.5C18.8332 7.56658 18.8332 7.09987 18.6515 6.74335C18.4917 6.42975 18.2368 6.17478 17.9232 6.01499C17.5666 5.83333 17.0999 5.83333 16.1665 5.83333H4.83317C3.89975 5.83333 3.43304 5.83333 3.07652 6.01499C2.76292 6.17478 2.50795 6.42975 2.34816 6.74335C2.1665 7.09987 2.1665 7.56658 2.1665 8.5V14.8333C2.1665 15.7668 2.1665 16.2335 2.34816 16.59C2.50795 16.9036 2.76292 17.1586 3.07652 17.3183C3.43304 17.5 3.89975 17.5 4.83317 17.5Z",
    stroke: "#444CE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobBreifCase);
export default __webpack_public_path__ + "static/media/jobBreifCase.a737a1219e33407832e36451b625eedb.svg";
export { ForwardRef as ReactComponent };